import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              常见问答
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              关于吃瓜爆料，你想知道的都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
              >
                <h3 className="text-base md:text-lg font-display text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                  {item.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}